declare global {
  interface Window {
    /** Set in layout <head> before GTM loads; reused for the first page_view + CAPI pair. */
    __pageViewEventId?: string;
  }
}

/**
 * Inline script for layout `<head>`. Must run before GTM so GA4 page_view can read
 * the same `event_id` from the dataLayer (configure GTM: Event parameter event_id = DLV event_id).
 */
export const PAGE_VIEW_EVENT_ID_SEED_SCRIPT = `
(function(){
  var id=(typeof crypto!=='undefined'&&crypto.randomUUID)?crypto.randomUUID():String(Date.now());
  window.__pageViewEventId=id;
  window.dataLayer=window.dataLayer||[];
  window.dataLayer.push({event_id:id});
})();
`;

/** Returns the head-seeded id for the initial page load, or creates one if missing. */
export const getInitialPageViewEventId = (): string => {
  if (typeof window === 'undefined') {
    return crypto.randomUUID();
  }

  if (!window.__pageViewEventId) {
    window.__pageViewEventId = crypto.randomUUID();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_id: window.__pageViewEventId });
  }

  return window.__pageViewEventId;
};
